import { Grid } from "@material-ui/core";
import {
  InputTextMaster,
  InputOptionMaster,
  InputFileCustom,
  MasterButton,
} from "App/Component/ui";
import {
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState } from "react";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { urlUploadStockOpname } from ".";

const SHOW_LOAD_BUTTON = {
  label: "Upload",
  color: "green",
  state: false,
};

function FormInputAdjusmentStock({
  formData,
  setFormData,
  file,
  setFile,
  setRowsTidakDitemukan,
  setRowsGagal,
  setNewAllData,
}) {
  const [disabled, setDisabled] = useState(SHOW_LOAD_BUTTON);
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const gudangUtama = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudangPBF.getGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "data"
  );

  const handleClickUpload = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.id)) {
        setDisabled(SHOW_LOAD_BUTTON);
        defaultToastError("Buka transaksi terlebih dahulu");
      } else {
        if (isNull(file)) {
          defaultToastError("File tidak boleh kosong");
          setDisabled(SHOW_LOAD_BUTTON);
        } else {
          const newFormData = new FormData();
          newFormData.append("gudang_id", formData.gudang_id);
          newFormData.append("excelFile", file);
          newFormData.append("stockOpname_id", formData.id);

          const res = await instance4.post(urlUploadStockOpname, newFormData);

          if (res.data.status === 200) {
            defaultToastSuccess(res.data.message);
            setDisabled(SHOW_LOAD_BUTTON);
            await setNewAllData();
          } else {
            await setNewAllData();
            defaultToastSuccess(res.data.message);
            setDisabled(SHOW_LOAD_BUTTON);
            setRowsGagal(res.data.tidakSesuai);
            setRowsTidakDitemukan(res.data.selisih);
          }
        }
      }
    } catch (error) {
      setDisabled(SHOW_LOAD_BUTTON);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item sm={4}>
          <InputTextMaster
            name='id'
            label='ID'
            readOnly
            disabled
            id='id'
            value={formData.id}
            onChange={handleChange("id")}
            placeholder='ID'
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='date'
            label='TANGGAL'
            id='date'
            readOnly={isNull(formData.id) ? false : true}
            disabled={isNull(formData.id) ? false : true}
            type='datetime-local'
            value={formData.date}
            onChange={handleChange("date")}
            placeholder='date'
          />
        </Grid>
        <Grid item sm={4}>
          <InputOptionMaster
            name='gudang_id'
            label='GUDANG UTAMA MEDIS'
            id='gudang_id'
            readOnly={isNull(formData.id) ? false : true}
            disabled={isNull(formData.id) ? false : true}
            withSearch={true}
            data={gudangUtama}
            value={formData.gudang_id}
            labelValue={formData.gudang}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  gudang: "Pilih Gudang",
                  gudang_id: null,
                });
              } else {
                setFormData({
                  ...formData,
                  gudang: e.label,
                  gudang_id: e.value,
                });
              }
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item sm={11}>
          <div className='mt-05'>
            <label
              htmlFor='fileSOPBF'
              style={{
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}>
              Pilih File
            </label>
            <InputFileCustom
              convertToBase64={false}
              label={"Upload File"}
              name={"file"}
              id={"fileSOPBF"}
              initialNameFile={file}
              setFile={setFile}
            />
          </div>
        </Grid>
        <Grid item sm={1}>
          <MasterButton
            className={"mt-2"}
            type='submit'
            disabled={isNull(formData.id) || disabled.state ? true : false}
            color={isNull(formData.id) ? "secondary" : disabled.color}
            name={disabled.label}
            size='lg'
            onClick={() => handleClickUpload()}
            style={{
              padding: "0.6rem 2rem",
              fontSize: "15px",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default FormInputAdjusmentStock;
